import { render, staticRenderFns } from "./__TemBao.vue?vue&type=template&id=e950aca8&"
import script from "./__TemBao.vue?vue&type=script&lang=js&"
export * from "./__TemBao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports